<ion-header class="ion-no-border custom-menu-header">
    <ion-toolbar>
        <ion-title>{{ 'pages.menu.appTitle' | translate }}</ion-title>
        <ion-buttons slot="end">
            <ion-menu-toggle>
                <ion-button>
                    <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
                </ion-button>
            </ion-menu-toggle>
        </ion-buttons>
    </ion-toolbar>
</ion-header>
<ion-content>
    <ion-list lines="none">
        <ion-menu-toggle auto-hide="false">
            @for(p of menuItems; track p.url) {
            <ion-item [routerLink]="p.url" routerLinkActive="selected" routerDirection="root" detail="false"
                class="menu-item">
                <ion-icon slot="start" [name]="p.url === '/dashboard' ? 'grid-outline' : 
                              p.url === '/bluetooth' ? 'bluetooth-outline' : 
                              p.icon + '-outline'"></ion-icon>
                <ion-label>{{ p.title | translate }}</ion-label>
            </ion-item>
            }
        </ion-menu-toggle>
    </ion-list>

    @if (adminPages?.length) {
        <ion-list lines="none">
            <ion-list-header>{{ 'pages.menu.admin' | translate }}</ion-list-header>
            <ion-menu-toggle auto-hide="false">
                @for(p of adminPages; track p.url) {
                    <ion-item [routerLink]="p.url" routerLinkActive="selected" [routerLinkActiveOptions]="{ exact: true }"
                            routerDirection="root" detail="false" class="menu-item" (click)="onAdminMenuClick(p, $event)">
                            <ion-icon slot="start" [name]="p.icon + '-outline'"></ion-icon>
                            <ion-label>
                                {{ p.title | translate }}
                                @if (p.email) {
                                    <ion-note>{{ p.email }}</ion-note>
                                }
                            </ion-label>
                    </ion-item>
                }
            </ion-menu-toggle>
        </ion-list>
    }


    <ion-list lines="none">
        <ion-list-header>{{ 'pages.menu.account' | translate }}</ion-list-header>
        <ion-menu-toggle auto-hide="false">

            @for(item of accountMenuItems; track item.icon) {
                <ion-item class="menu-item" (click)="menuAction(item)">
                    <ion-icon slot="start" [name]="item.icon + '-outline'"></ion-icon>
                    <ion-label>
                        {{ item.title | translate }}
                        @if (item.email) {
                            <ion-note class="email-note">{{ item.email }}</ion-note>
                        }
                    </ion-label>
                </ion-item>
            }

            <ion-item button (click)="logout()" class="menu-item">
                <ion-icon slot="start" name="log-out-outline"></ion-icon>
                <ion-label>{{ 'pages.menu.logout' | translate }}</ion-label>
            </ion-item>
        </ion-menu-toggle>
    </ion-list>
</ion-content>
